// @ts-nocheck
import Card from '@rio-cloud/rio-uikit/Card';
import Illustration from '@rio-cloud/rio-uikit/Illustration';
import PropTypes from 'prop-types';
import { cloneElement } from 'react';
import { injectIntl } from 'react-intl';

export const StartPanelCardWithoutInjection = ({ illustrationName, headline, text, buttons }) => (
    <Card className='width-100pct' padding={20}>
        <div className='display-flex-md align-items-start gap-20'>
            <div className='flex-basis-33pct-md margin-bottom-20 margin-bottom-0-md padding-top-10'>
                <Illustration
                    className='img-responsive min-width-100 max-width-100'
                    name={illustrationName}
                    size={150}
                />
            </div>
            <div className='flex-1-1'>
                <h2 className='text-size-h3 margin-top-0 margin-bottom-15'>{headline}</h2>

                <p className='margin-bottom-15'>{text}</p>

                <div className='display-flex flex-wrap gap-10'>
                    {buttons.map(button =>
                        cloneElement(button, {
                            key:
                                button.key ?? button.props.href ?? button.props['data-testid'] ?? button.props.children,
                        })
                    )}
                </div>
            </div>
        </div>
    </Card>
);

StartPanelCardWithoutInjection.propTypes = {
    illustrationName: PropTypes.string.isRequired,
    headline: PropTypes.node.isRequired,
    text: PropTypes.node.isRequired,
    buttons: PropTypes.arrayOf(PropTypes.node),
};

export default injectIntl(StartPanelCardWithoutInjection);
